import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';
import { customSearchUiPlugin } from './plugin';

export const CustomTechDocsSearchResultListItem = customSearchUiPlugin.provide(
  createSearchResultListItemExtension({
    name: 'CustomTechDocsSearchResultListItem',
    component: () =>
      import('./components/CustomTechDocsSearchResultListItem').then(
        m => m.CustomTechDocsSearchResultListItem,
      ),
    predicate: _ => true, // Match all results
  }),
);
